export const defaultWalletCurrency = 'CZK';

export const minWithdrawalAmount = 0.01;
export const minOfferInvestmentAmount = 0.01;

export * from './urls';
export * from './LegalDocuments';
export * from './remoteConfigDefaults';
